module.exports = __webpack_public_path__ + "static/media/goNext.6d8f1b3c.svg";